__webpack_require__.p = "https://m.withvector7.com/";